import type { TuitionFeeBenchmarkSchoolRow } from '@/features/reports/data/tuitionFeeBenchmark.types';
import { statusLabel } from '@/features/reports/data/tuitionFeeBenchmarkMock';
import { downloadStringMatrixAsPdf, downloadStringMatrixAsXlsx } from '@/features/reports/utils/teacherEquityAlertExports';

function fmtUsd(n: number): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n);
}

function fmtPct(n: number): string {
  const sign = n > 0 ? '+' : '';
  return `${sign}${n.toFixed(1)}%`;
}

const EXPORT_HEADERS = [
  'School',
  'Code',
  'Governorate',
  'District',
  'Area',
  'Students',
  'Tuition/student',
  'Regional avg',
  'National avg',
  'vs Regional %',
  'vs National %',
  'Status',
];

export function buildTuitionFeeBenchmarkExportMatrix(
  rows: TuitionFeeBenchmarkSchoolRow[]
): string[][] {
  return rows.map((r) => [
    r.schoolName,
    r.schoolCode,
    r.governorateName,
    r.cityName,
    r.areaName,
    String(r.studentsInGrade),
    fmtUsd(r.tuitionPerStudentUsd),
    fmtUsd(r.regionalBenchmarkUsd),
    fmtUsd(r.nationalBenchmarkUsd),
    fmtPct(r.varianceRegionalPct),
    fmtPct(r.varianceNationalPct),
    statusLabel(r.benchmarkStatus),
  ]);
}

export async function exportTuitionFeeBenchmarkExcel(
  rows: TuitionFeeBenchmarkSchoolRow[],
  basename: string
): Promise<void> {
  const matrix = buildTuitionFeeBenchmarkExportMatrix(rows);
  await downloadStringMatrixAsXlsx(basename, 'Tuition benchmark', EXPORT_HEADERS, matrix);
}

export async function exportTuitionFeeBenchmarkPdf(
  rows: TuitionFeeBenchmarkSchoolRow[],
  basename: string,
  subtitles: string[]
): Promise<void> {
  const matrix = buildTuitionFeeBenchmarkExportMatrix(rows);
  await downloadStringMatrixAsPdf(basename, subtitles, EXPORT_HEADERS, matrix);
}

export function tuitionFeeBenchmarkExportBasename(year: string, gradeId: string): string {
  return `tuition-fee-benchmark_${year}_${gradeId}`;
}
